import { useEffect, useState } from 'react'

const THRESHOLD_VALUE = 2
const isNavigationAvailable = () => {
  return typeof window !== 'undefined' && navigator
}

function useNetworkStatus(threshold = THRESHOLD_VALUE) {
  const [isSlowNetwork, setIsSlow] = useState(false)
  const [isOfflineNetwork, setIsOffline] = useState(
    isNavigationAvailable() ? !navigator?.onLine : false,
  )

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if ('connection' in navigator) {
        const connection =
          navigator?.connection || navigator?.mozConnection || navigator?.webkitConnection

        // Function to check connection speed
        const checkNetworkSpeed = () => {
          const downlink = connection.downlink
          if (downlink == 0) {
            setIsOffline(true)
            setIsSlow(false)
          } else {
            setIsOffline(false)
            setIsSlow(downlink < threshold)
          }
        }

        checkNetworkSpeed()

        connection.addEventListener('change', checkNetworkSpeed)

        // Cleanup on component unmount
        return () => {
          connection.removeEventListener('change', checkNetworkSpeed)
        }
      } else if (!('connection' in navigator)) {
        // eslint-disable-next-line no-console
        console.warn('Network Information API is not supported by this browser.')
      }
    }
  }, [threshold])

  // Handle offline and online events
  useEffect(() => {
    const handleOffline = () => setIsOffline(true)
    const handleOnline = () => setIsOffline(false)

    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('online', handleOnline)
    }
  }, [])

  return { isSlowNetwork, isOfflineNetwork }
}
export default useNetworkStatus
